// extracted by mini-css-extract-plugin
export default {"page":"StatementsPage_page__NjV9W","loaderWrap":"StatementsPage_loaderWrap__Ik2I2"};